import { nanoid } from "nanoid";
import React from "react";

import { Button } from "~/components/button";
import { For } from "~/components/for";
import { FormField } from "~/components/form/field";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";

import { type FormState, initSeriesSelectorState } from "./_form-state";
import { Selector } from "./_selector";

export interface SeriesSelectorsProps {
	state: FormState;
}

export const SeriesSelectors: React.FC<SeriesSelectorsProps> = ({ state }) => (
	<FormField className="items-stretch" state={state}>
		<FormLabel asChild>
			<div>
				<FormLabel>Series Selectors</FormLabel>
				<FormFieldReset />
			</div>
		</FormLabel>

		{(scope, field) => (
			<For className="mb-4 space-y-2" each={field.getElements(scope)}>
				{(value) => {
					const id = value.fields.id(scope);

					return (
						<Selector
							key={id}
							onDelete={() => {
								state.setElements((values) =>
									values.filter(({ fields }) => fields.id(scope) !== value.fields.id(scope)),
								);
							}}
							state={value}
						/>
					);
				}}
			</For>
		)}

		<Button
			className="uppercase"
			onClick={() => {
				state.setElements((values) => [...values, initSeriesSelectorState(nanoid())]);
			}}
			variant="primary"
		>
			Add series selector
		</Button>
	</FormField>
);
